<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<div style="text-align: center; line-height: 80px; font-size: 18px;">
			报名已截止
		</div>
		
		<div v-if="!stuForm.id&&false" style="padding: 15px;">
			<van-cell-group>

				<div style="text-align: center; background-color: #fff; padding: 20px;">{{school_name}}</div>
				<div style="height: 50px;"></div>
				<!-- 	<van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" /> -->
				<van-field v-model="stuForm.identity_card" label="身份证号" placeholder="请输入考生身份证号" />
				<div style="height: 50px;"></div>
				<div class="submitBtn flexAround">
					<div class="btn" @click="onSearch" style="width: 40%;">查询</div>
				</div>
				<div style="height: 50px;"></div>
			</van-cell-group>
		</div>


		<div v-else>

			<van-cell-group v-if="false">

				<div style="padding: 20px; font-size: 14px; position: relative;">
					<div style="font-weight: bold;">
						报名信息
					</div>
					<div style="padding-top: 10px; color: #888;">
						报名时间：{{stuForm.cdate}}
					</div>

					<div style="position: absolute; top: 10px; right: 30px; width: 60px;">
						<img v-if="stuForm.status==0" src="//aiwx.org.cn/static/icon/static/sp_normal.png"
							style="width: 100%;">
						<img v-if="stuForm.status==1" src="//aiwx.org.cn/static/icon/static/sp_over.png"
							style="width: 100%;">
						<img v-if="stuForm.status==-1" src="//aiwx.org.cn/static/icon/static/sp_fail.png"
							style="width: 100%;">

					</div>
					<div style="font-size: 12px; color: orangered;" v-if="stuForm.status==-1">
						{{stuForm.sp_word}}
					</div>

				</div>

				<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
					<span class="rowlabel"></span><span style="color: orangered;">*</span>兼报专业
				</div>

				<van-field v-model="major_name2" is-link readonly label="兼报专业" placeholder="请选择报考专业"
					@click="showMajorList" required />
				<div v-if="!disabled" style="color: orangered; font-size: 12px; text-align: center;">
					专业提交后无法修改，请谨慎选择！

				</div>
				<van-popup v-model="showMj1" round position="bottom">
					<van-cascader v-model="major_id2" title="请选择兼报专业" active-color="#1989fa" :options="majors"
						:field-names="fieldMajors" @close="showMj1 = false" @finish="onCheckMajor" />
				</van-popup>

				<van-field :readonly="true" v-model="xuezhi" label="学制" placeholder="请选择专业" />

				<div style="margin-top: 20px;" v-if="!disabled">
					<div class="submitBtn flexCenter">
						<div class="btn flexCenter" @click="saveStu">提交</div>
					</div>



				</div>



				<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
					<span class="rowlabel"></span>考生信息
				</div>

				<van-field readonly v-model="stuForm.stu_name" label="考生姓名" label-width="110px" />
				<van-field readonly v-model="stuForm.phone" label="手机号" label-width="110px" />
				<van-field readonly :value="stuForm.identity_card" label="身份证号" label-width="110px" />
				<van-field readonly :value="stuForm.gender==1?'男':'女'" label="性别" label-width="110px" />

				<van-field readonly v-model="stuForm.major.title" label="报考专业名称" label-width="110px" />
				<van-field readonly v-model="stuForm.major.item_desc" label="学制" label-width="110px" />

				<van-field readonly v-model="stuForm.graduate_schname" label="证件照" label-width="110px">
					<template #input>
						<div style="width: 20%; margin: 0 auto;">
							<img :src="stuForm.otherjson.dzzj" style="width: 100%;" />
						</div>

					</template>
				</van-field>




				<div style="height: 50px;">

				</div>
			</van-cell-group>


		</div>


	</div>




</template>

<script>
	import {
		Dialog,
		Toast,
		Uploader
	} from 'vant';
	export default {
		components: {

		},
		data() {
			return {
				school_name: "江苏省戏剧学校",
				stuForm: {
					id: 0,
					identity_card: ""
				},
				pmid: 6,
				openid: "",
				major_id2: "",
				major_name2: "",
				fieldMajors: {
					text: 'title',
					value: 'id',
					children: 'children',
				},
				majors: [],
				showMj1: false,
				xuezhi: "",
				disabled: false
			}
		},
		mounted() {
			document.title = "兼报专业报名"
			this.pmid = this.$route.query.pmid || 6
			this.openid = this.$route.query.openid

			if (this.openid) {
				//this.getStudentsByOpenid()
			}

		},
		methods: {
			onSearch() {
				//alert("未到开放查询时间")
				if (!this.stuForm.identity_card) {
					Toast('请输入正确的身份证号');
				} else {
					var myreg =
						/(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
					if (!myreg.test(this.stuForm.identity_card)) {
						Toast('请输入正确的身份证号');
						return
					} else {
						this.getStudents()
					}



				}
			},
			resetForm() {
				this.stuForm = {
					id: 0,
					identity_card: ""
				}
			},
			getStudents() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					identity_card: this.stuForm.identity_card
				}).then(res => {

					if (res.data) {
						res.data.otherjson = JSON.parse(res.data.otherjson)
						this.stuForm = res.data
						this.getMajorList()
					} else {
						Dialog.alert({
							title: '提示',
							message: '未找到报名信息！',
							theme: 'round-button',
						}).then(() => {
							// on close
						});
					}



				})
			},
			getStudentsByOpenid() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {

					if (res.data) {
						res.data.otherjson = JSON.parse(res.data.otherjson)
						this.stuForm = res.data
						this.getMajorList()
					} else {

					}
				})
			},
			getMajorList() {
				
				
				
				this.$http.post("/api/app_major_list", {
					pmid: this.pmid,
					node_type: "major"
				}).then(res => {
					//检查第一专业是不是艺术设计，艺术设计不能兼报
					let arr = [];
					let omajor=[];
					if (this.stuForm.major){
						for(let m of res.data){//按年龄过滤下专业
							if(m.item_desc==this.stuForm.major.item_desc){
								omajor.push(m)
							}else{
								console.log("排除专业")
								console.log(m)
							}
						}
					}
					
					if (this.stuForm.major && this.stuForm.major.title.indexOf("艺术设计") >= 0) {
						for (let m of omajor) {
							if (m.title.indexOf("艺术设计") < 0) {
								arr.push(m)

							}
						}
					} else {
						for (let m of omajor) {
							if (m.id != this.stuForm.major_id) {
								arr.push(m)
							}
						}
					}
					this.majors = arr
					if(arr.length>0){
						this.getMajor2()
					}else{
						Dialog.alert({
							title: '提示',
							message: '您选择的主专业不支持兼报专业！',
							theme: 'round-button',
						}).then(() => {
						
						});
					}
					
				})



			},
			getMajor2() {

				this.$http.post("/api/app_stupre_info", {
					pmid: this.pmid,
					id: this.stuForm.pre_id || this.stuForm.id
				}).then(res => {

					if (res.data && res.data.major_id2) {
						this.major_id2 = res.data.major_id2
						//this.disabled = true
						for (let m of this.majors) {
							if (m.id == this.major_id2) {
								this.major_name2 = m.title;
								this.xuezhi = m.item_desc
								break
							}
						}
						this.disabled = true
					}
				})
			},
			showMajorList() {


				if (!this.disabled) {
					this.showMj1 = true
				}
			},
			onCheckMajor(e) {
				this.major_id2 = e.selectedOptions[0].id
				this.major_name2 = e.selectedOptions[0].title
				this.showMj1 = false
				this.xuezhi = e.selectedOptions[0].item_desc
			},
			saveStu() {
				
				if(!this.major_id2){
						Toast('请选择兼报专业');
						return
				}
				
				Dialog.confirm({
					title: '报名提醒',
					message: '确认提交报名信息，专业提交后不支持修改！',
					theme: 'round-button',
				}).then(() => {
					this.$http.post("/api/save_major2", {
						pmid: this.pmid,
						id: this.stuForm.pre_id || this.stuForm.id,
						major_id2: this.major_id2
					}).then(res => {
						this.disabled = true
						Dialog.alert({
							title: '报名成功',
							message: '提交成功，您的兼报专业已提交！',
							theme: 'round-button',
						}).then(() => {
							this.$router.push("/bmfee?pmid=6&openid="+this.openid)
						});
					})
				})

			},
			checkAge() {
			
				let year = new Date().getFullYear()
				let y1 = {
					sdate: 0,
					edate: 0
				}
				let y2 = {
					sdate: 0,
					edate: 0
				}
				y1.sdate = parseInt(year - 17 + "0901")
				y1.edate = parseInt(year - 15 + "0831")
			
				y2.sdate = parseInt(year - 14 + "0901")
				y2.edate = parseInt(year - 12 + "0831")
			
				let birth = parseInt(this.stuForm.birthday.replace(/-/g, ''))
			
				console.log(birth, y1.sdate, y2.edate)
				if (birth < y1.sdate || birth > y2.edate) {
					return false
				} else {
					if (birth >= y1.sdate && birth <= y1.edate) { //五年制
						return 5
					} else if (birth >= y2.sdate && birth <= y2.edate) { //六年制
						return 6
					} else {
						return false
					}
				}
			
			},
		},
	}
</script>


<style lang="less" type="text/less">
	.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #00cfdc;
  border-color: #00cfdc;
}
	.submitBtn {
        margin-top: 2vh;
		margin-bottom: 50px;

        .btn {
            display: inline-block;
            padding: 1.4vh 8%;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 5vw;
			width: 50%;
			text-align:center;
        }
		.btn:active {

		    background-color: #007AFF;

		}
    }
	.xm{ border:1px solid #ccc; display: inline-block; margin:0 10px 10px 0; padding: 4px 10px; border-radius: 4px;}
	.xmckd{ background-color: orangered; color:#fff;}
</style>

</style>
